import { Alert, Box, Stack, TextField, Typography } from '@mui/material';

/** Limites do BR Code (campos 59 e 60) — o banco recusa o código acima disso. */
export const MAX_NOME_RECEBEDOR_PIX = 25;
export const MAX_CIDADE_PIX = 15;

export interface DadosPixEstatico {
  pixChave: string;
  pixNomeRecebedor: string;
  pixCidade: string;
}

/**
 * Chave Pix da forma LOCAL + PIX. Com ela, o pedido confirmado mostra ao cliente
 * o QR Code e o "copia e cola" com o valor do pedido. Em branco, nada muda.
 */
export function CamposPixEstatico({
  dados,
  aoMudar,
  temWhatsapp,
}: {
  dados: DadosPixEstatico;
  aoMudar: (dados: DadosPixEstatico) => void;
  temWhatsapp: boolean;
}): JSX.Element {
  const comChave = !!dados.pixChave.trim();
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, p: 2 }}>
      <Typography variant="subtitle2">QR Code Pix para o cliente (opcional)</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Com a chave preenchida, quando você confirmar um pedido de delivery o cliente vê o QR Code e o
        "Pix copia e cola" com o valor do pedido, e é orientado a enviar o comprovante para a loja.
      </Typography>

      <Stack spacing={2}>
        <TextField
          label="Chave Pix"
          value={dados.pixChave}
          onChange={(e) => aoMudar({ ...dados, pixChave: e.target.value })}
          fullWidth
          placeholder="CPF, CNPJ, celular, e-mail ou chave aleatória"
          helperText="Celular com DDD, ex.: (11) 98765-4321. Deixe em branco para não mostrar o QR Code."
          inputProps={{ maxLength: 100 }}
        />
        {comChave && (
          <>
            <TextField
              label="Nome de quem recebe"
              value={dados.pixNomeRecebedor}
              onChange={(e) => aoMudar({ ...dados, pixNomeRecebedor: e.target.value })}
              fullWidth
              required
              helperText={`Como aparece no banco do cliente. Até ${MAX_NOME_RECEBEDOR_PIX} letras.`}
              inputProps={{ maxLength: MAX_NOME_RECEBEDOR_PIX }}
            />
            <TextField
              label="Cidade"
              value={dados.pixCidade}
              onChange={(e) => aoMudar({ ...dados, pixCidade: e.target.value })}
              fullWidth
              required
              helperText={`Cidade da conta que recebe. Até ${MAX_CIDADE_PIX} letras.`}
              inputProps={{ maxLength: MAX_CIDADE_PIX }}
            />
            {!temWhatsapp && (
              <Alert severity="info" variant="outlined">
                A loja não tem WhatsApp cadastrado. O cliente será orientado a mandar o comprovante pelo
                Instagram ou outro contato da loja. Para receber pelo WhatsApp, cadastre o número em
                Configurações.
              </Alert>
            )}
          </>
        )}
      </Stack>
    </Box>
  );
}
